import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import DataTable from '~/react/components/DataTable'

import StatusCell from '../../../../components/StatusCell'
import DateCell from '../../../../components/DateCell'

import PartnerCell from './PartnerCell'
import PointsCell from './PointsCell'

const RedemptionActivitiesTable = ({activities, isLoading}) => {
  const {t} = useTranslation('points')

  const sortedActivities = [...activities]
    .sort((a, b) => new Date(b.requestedDate) - new Date(a.requestedDate))
    .map((activity) => ({
      ...activity,
      partner: {
        name: activity.partnerName,
        key: activity.partnerKey,
        memberStatus: activity.partnerMemberStatus,
      },
      partnerPoints: activity.partnerPoints,
    }))

  const columns = [
    {
      header: t('points:redemptionActivitiesScreen.table.partner'),
      accessorKey: 'partner',
      cell: PartnerCell,
    },
    {
      header: t('points:redemptionActivitiesScreen.table.requestedDate'),
      accessorKey: 'requestedDate',
      cell: DateCell,
      meta: {style: {textAlign: 'center'}},
    },
    {
      header: t('points:redemptionActivitiesScreen.table.mCoins'),
      accessorKey: 'mCoins',
      cell: PointsCell,
      meta: {isNumeric: true, style: {textAlign: 'center'}},
    },
    {
      header: t('points:redemptionActivitiesScreen.table.partnerPoints'),
      accessorKey: 'partnerPoints',
      cell: PointsCell,
      meta: {isNumeric: true},
    },
    {
      header: t('points:redemptionActivitiesScreen.table.status'),
      accessorKey: 'status',
      meta: {isNumeric: true},
      cell: StatusCell,
    },
  ]

  return (
    <Box width="100%" overflowX={{xl: 'visible', base: 'scroll'}}>
      <Box width="100%" flexGrow="1" whiteSpace="nowrap">
        <DataTable
          data={sortedActivities}
          columns={columns}
          chakraTableProps={{size: 'sm'}}
          sortByValue={[{id: 'requestedDate', desc: true}]}
          isLoading={isLoading}
        />
      </Box>
    </Box>
  )
}

RedemptionActivitiesTable.propTypes = {
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      partnerName: PropTypes.string.isRequired,
      partnerKey: PropTypes.string.isRequired,
      partnerMemberStatus: PropTypes.string,
      partnerLogoUrl: PropTypes.string,
      mCoins: PropTypes.number.isRequired,
      partnerPoints: PropTypes.number.isRequired,
      status: PropTypes.oneOf(['processing', 'successful', 'failed', 'unknown'])
        .isRequired,
      requestedDate: PropTypes.string.isRequired,
    }),
  ).isRequired,
  isLoading: PropTypes.bool,
}

RedemptionActivitiesTable.defaultProps = {
  isLoading: false,
}

export default RedemptionActivitiesTable
